import React from 'react';
import { isNullOrWhitespace } from 'js/utils/string';
import { PanelHeader, Icon } from 'js/components';
import { Breadcrumbs } from 'js/components/Breadcrumbs';
import { Link, useParams } from 'react-router-dom';
import TeamTabs from './TeamTabs';

/**
 * Shared page layout for team dashboard, settings, and connector views:
 * breadcrumbs, title, Assess button, TeamTabs (wired from connector configs), and content.
 */
function TeamPageLayout({
  team = null,
  teamConnectorConfigurations = [],
  teamConnectorConfigurationsHasLoaded = false,
  headerContent = null,
  children = null,
}) {
  const { workspaceId, teamId } = useParams();

  const breadcrumbs = [{ label: 'Teams', to: `/w/${workspaceId}/teams` }];

  return (
    <div>
      <PanelHeader size="flex">
        <div className="panel-body-no-label px-4">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className="content-fluid">
            <div className="row">
              <div className="col-12 col-md-9">
                <h1>{team?.name ?? 'Loading…'}</h1>
                {team && !isNullOrWhitespace(team?.description) && (
                  <p>{team.description}</p>
                )}
              </div>
              <div className="panel-actions col-12 col-md-3">
                <Link
                  className="btn btn-primary create-link"
                  to={`/w/${workspaceId}/teams/${teamId}/assessments/new`}
                >
                  <Icon
                    icon={['far', 'poll']}
                    size="lg"
                    className="btn-icon-left"
                  />
                  Assess
                </Link>
              </div>
            </div>
            {headerContent}
          </div>
        </div>
        <div className="container-fluid">
          <TeamTabs
            teamConnectorConfigurations={teamConnectorConfigurations}
            teamConnectorConfigurationsHasLoaded={
              teamConnectorConfigurationsHasLoaded
            }
          />
        </div>
      </PanelHeader>

      <div className="content">{children}</div>
    </div>
  );
}

export default TeamPageLayout;
